import { RootState } from '@atredux/store'

export const getIsConnectionsFinished = (state: RootState): boolean =>
  state.connections.isConnectionsFinished
